import { FC, ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as ArrowRightSvg } from 'assets/svg/arrow-right.svg';
import { cn } from 'utils/global';

interface Props {
  image?: React.ReactNode;
  label?: string;
  dropdownIcon?: boolean;
  labelClassName?: string;
  className?: string;
  children?: ReactNode;
  onClick?: VoidFunction;
  dataCy?: string;
}

const MenuItem: FC<Props> = ({ image, label, labelClassName, dropdownIcon, className, children, onClick, dataCy }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        data-cy={dataCy}
        onClick={onClick}
        className={cn(
          'menu-item group flex items-center px-3 py-1.5 bg-white-00 dark:bg-black-900 group hover:!bg-neutral-100 dark:hover:!bg-neutral-900',
          { 'pl-9': !image },
          className
        )}
      >
        {image}
        <p className={cn('text-sm text-neutral-700 dark:text-neutral-300 ml-1', labelClassName)}>{t(label || '')}</p>
      </div>
      {dropdownIcon && <ArrowRightSvg className="w-[5px] fill-neutral-700 dark:fill-neutral-300" />}
      {children}
    </>
  );
};

export default MenuItem;
